import { render, staticRenderFns } from "./mayiba_fenlei.vue?vue&type=template&id=79184610&"
import script from "./mayiba_fenlei.vue?vue&type=script&lang=js&"
export * from "./mayiba_fenlei.vue?vue&type=script&lang=js&"
import style0 from "./mayiba_fenlei.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports